import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { TableHandler, Col, Row } from '../../../../../../classes';

@Component({
  selector: '[header-cell]',
  templateUrl: './header-cell.component.html',
  styleUrls: ['./header-cell.component.scss']
})
export class HeaderCellComponent implements OnInit {
  @Input() table:TableHandler;
  @Input() col:Col;
  @Input() row:Row;
  get value () {
    if (this.row.priority === 0) return this.col.text;
    else if (this.col.priority === 0) return this.row.text;
  }
  set value (v:string) {
    if (this.row.priority === 0) this.col.text = v;
    else if (this.col.priority === 0) this.row.text = v;
  }
  constructor(
    private elementRef:ElementRef,
    private renderer:Renderer2,
  ) { }

  ngOnInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'position-relative');
    this.renderer.addClass(this.elementRef.nativeElement, 'noselect');
    if (this.col.priority === 0) this.renderer.addClass(this.elementRef.nativeElement, 'left-header');
    else if (this.row.priority === 0) this.renderer.addClass(this.elementRef.nativeElement, 'top-header');
  }

}
